import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c284c530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("p", null, "个人认证"),
  /*#__PURE__*/_createElementVNode("div", { class: "yellow" }),
  /*#__PURE__*/_createElementVNode("div", { class: "black" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.selfverifyForm.currentView), {
      onGoback: _ctx.goback,
      onChangeInformation: _ctx.changeInformation
    }, null, 40, ["onGoback", "onChangeInformation"]))
  ]))
}